export default __webpack_public_path__ + "fe34d54beaffc234e9d8194c62335038.png";